module.exports = __webpack_public_path__ + "img/dynamic-12.676852a0.png";